import { Card, Flex, Link, TextHeading } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { styled } from "styled-components";

export interface LegacyHelpPanelButtonProps {
  text: string;
  href?: string;
  onClick?: () => void;
  Icon?: any;
}

const StyledCardWrapper = styled.div`
  width: 100%;
`;

const StyledStackWrapper = styled(Flex)`
  && a:last-child > p {
    padding-bottom: 0px;
  }
`;

export interface LegacyHelpPanelProps {
  helpItems: LegacyHelpPanelButtonProps[];
}

export const LegacyHelpPanel = ({ helpItems }: LegacyHelpPanelProps) => {
  const intl = useIntl();

  return (
    <StyledCardWrapper>
      <Card padding="large">
        <Flex direction="column" gap="2">
          <TextHeading>
            {intl.formatMessage({
              id: "shared-ui: need help with this title",
              defaultMessage: "Need help with this?",
            })}
          </TextHeading>
          <StyledStackWrapper gap="1" direction="column">
            {helpItems.map((helpItem, index) => (
              <Link key={index} url={helpItem.href} onClick={helpItem.onClick} external>
                {helpItem.text}
              </Link>
            ))}
          </StyledStackWrapper>
        </Flex>
      </Card>
    </StyledCardWrapper>
  );
};
